export default function Footer() {
  return (
    <footer className="w-full border-t mt-5">
      <div className="max-w-5xl mx-auto px-3 h-16 sm:h-20 flex justify-center items-center text-sm gap-4">
        <div className="text-gray-500">
          © 2025 AIImageStudio
        </div>
        <a
          href="/appprivacypolicy/"
          className="hover:underline transition underline-offset-2"
        >
          Privacy Policy
        </a>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLScJ1HYJFoGfciWoT7wn6iFjaMa4xRlgJkdoe9aKd8p9J88nQQ/viewform?usp=sf_link"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline transition underline-offset-2"
        >
          Feedback
        </a>
      </div>
    </footer>
  );
}
